module.exports = __webpack_public_path__ + "img/device_remove.e3929bf0.png";